/* Ported from _deploy_baseline/_v3/light.js by _th-v3-tools/port_assets.py. Edit the source there, then re-run the port. */
/* THUNDER HONEY V3 light layer (light.css describes the picture and the layering).
   C is ON by default across the site (Joakim, 30 Sep 2026: "Do that effect for sure"). Review switches:
     ?light=a  pointer light          ?light=b  ambient silver field
     ?light=c  metal sheen, plus A at half strength (the default)          ?light=off  turns it off
   The choice, off included, is kept in sessionStorage for the visit, so internal links keep it.
   Desktop (hover and a fine pointer): the light follows the pointer with easing.
   Touch: no pointer, so the light drifts slowly with the scroll position instead.
   Off under prefers-reduced-motion (and it switches itself off if that setting turns on mid-visit).
   One requestAnimationFrame loop: it reads all rects before it writes, writes transform and opacity only,
   and sleeps when nothing moves and while the tab is hidden. The ambient shapes of B are CSS animations,
   paused while their section is off screen. */
(function () {
  'use strict';
  var w = window, d = document, html = d.documentElement, KEY = 'th-light';

  /* ---------- which variant, if any ---------- */
  var DEF = 'c';
  function ok(v) { return v === 'a' || v === 'b' || v === 'c'; }
  function pick() {
    var q = null, m = /[?&]light=([^&#]*)/i.exec(w.location.search || '');
    if (m) { try { q = decodeURIComponent(m[1]).toLowerCase(); } catch (e) { q = ''; } }
    try {
      if (q !== null) { if (ok(q) || q === 'off') w.sessionStorage.setItem(KEY, q); else w.sessionStorage.removeItem(KEY); }
      else { var s = w.sessionStorage.getItem(KEY); if (ok(s)) return s; if (s === 'off') return null; }
    } catch (e) { /* storage blocked: the address alone decides */ }
    if (q === 'off') return null;
    return ok(q) ? q : DEF;
  }
  var MODE = pick();
  if (!MODE || !d.querySelector || !w.requestAnimationFrame) return;

  function mm(q) { try { return w.matchMedia(q).matches; } catch (e) { return false; } }
  var RMQ = null;
  try { RMQ = w.matchMedia('(prefers-reduced-motion: reduce)'); } catch (e) {}
  if (RMQ && RMQ.matches) return;

  var FINE = mm('(hover: hover) and (pointer: fine)');
  var A = MODE === 'a' ? 1 : MODE === 'c' ? 0.5 : 0, B = MODE === 'b', C = MODE === 'c';
  html.classList.add('lt', 'lt-' + MODE, FINE ? 'lt-fine' : 'lt-touch');

  /* ---------- helpers ---------- */
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function smooth(v) { return v * v * (3 - 2 * v); }
  function cs(el) { return w.getComputedStyle(el); }
  function rgba(s) {
    var m = /rgba?\(\s*([\d.]+)[ ,]+([\d.]+)[ ,]+([\d.]+)(?:[ ,/]+([\d.]+%?))?/.exec(s || '');
    if (!m) return null;
    var a = m[4] === undefined ? 1 : /%$/.test(m[4]) ? parseFloat(m[4]) / 100 : parseFloat(m[4]);
    return [+m[1], +m[2], +m[3], a];
  }
  function lum(c) { return c ? (0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2]) / 255 : 0; }
  function span(cls) { var s = d.createElement('span'); s.className = cls; s.setAttribute('aria-hidden', 'true'); return s; }
  function distTo(r, x, y) {
    var ex = Math.max(0, Math.abs(x - (r.left + r.width / 2)) - r.width / 2);
    var ey = Math.max(0, Math.abs(y - (r.top + r.height / 2)) - r.height / 2);
    return Math.sqrt(ex * ex + ey * ey);
  }
  function setT(o, key, el, x, y) {
    if (o[key + 'x'] !== undefined && Math.abs(o[key + 'x'] - x) < 0.1 && Math.abs(o[key + 'y'] - y) < 0.1) return;
    o[key + 'x'] = x; o[key + 'y'] = y;
    el.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0)';
  }
  function setO(o, key, el, v) {
    if (o[key] !== undefined && Math.abs(o[key] - v) < 0.008) return;
    o[key] = v; el.style.opacity = v.toFixed(3);
  }
  function stacking(c) {
    return c.isolation === 'isolate' || (c.position !== 'static' && c.zIndex !== 'auto') || c.transform !== 'none' ||
      c.filter !== 'none' || parseFloat(c.opacity) < 1 || c.mixBlendMode !== 'normal' ||
      (c.backdropFilter && c.backdropFilter !== 'none') || (c.webkitBackdropFilter && c.webkitBackdropFilter !== 'none') ||
      /paint|strict|content|layout/.test(c.contain || '') || /transform|opacity|filter/.test(c.willChange || '');
  }
  /* can this element take position:relative without moving anything inside it? */
  function positionable(el, c) {
    if (c.position !== 'static') return true;
    var all = el.getElementsByTagName('*');
    for (var i = 0; i < all.length; i++) { var p = cs(all[i]).position; if (p === 'absolute' || p === 'fixed') return false; }
    return true;
  }
  function hasFixed(el) {
    var all = el.getElementsByTagName('*');
    for (var i = 0; i < all.length; i++) if (cs(all[i]).position === 'fixed') return true;
    return false;
  }
  function surface(c) {
    var bg = rgba(c.backgroundColor), bc = rgba(c.borderTopColor);
    return (bg && bg[3] > 0.04) || (parseFloat(c.borderTopWidth) > 0 && bc && bc[3] > 0.05) ||
      (c.backgroundImage && c.backgroundImage !== 'none') || (c.boxShadow && c.boxShadow !== 'none');
  }
  var NOKIDS = /^(IMG|VIDEO|CANVAS|INPUT|TEXTAREA|SELECT|IFRAME|SVG|PICTURE|DETAILS|SUMMARY|TABLE|THEAD|TBODY|TR|UL|OL|DL|HR|BR|SOURCE)$/;

  /* ---------- viewport and the light's position ---------- */
  var vw = 0, vh = 0, LSZ = 0;
  function view() {
    vw = w.innerWidth || html.clientWidth || 1; vh = w.innerHeight || html.clientHeight || 1;
    var n = Math.round(Math.max(vw, vh) * 1.05);
    if (n !== LSZ) { LSZ = n; html.style.setProperty('--lt-L', n + 'px'); }
  }
  view();
  /* tx,ty: where the light wants to be (viewport px); lx,ly: the lamp and fields (slow); sx,sy: the sheen (quicker) */
  var tx = vw * 0.5, ty = vh * 0.34;
  function drift() {
    var y = w.pageYOffset || html.scrollTop || 0;
    tx = vw * (0.5 + 0.34 * Math.sin(y / 820));
    ty = vh * (0.4 + 0.16 * Math.sin(y / 1270 + 1.3));
  }
  if (!FINE) drift();
  var lx = tx, ly = ty, sx = tx, sy = ty;

  /* ---------- sections ---------- */
  var secs = [], bodyBg = null;
  function lightGround(s, c) {
    var cl = s.className || '';
    if (s.classList.contains('hero') || /\bsec--(navy|photo)\b/.test(cl)) return false;
    if (/\bsec--(paper|stone|white)\b/.test(cl)) return true;
    if (/url\(/.test(c.backgroundImage)) return false;
    var g = rgba(c.backgroundColor);
    if (!g || g[3] < 0.5) { if (!bodyBg) bodyBg = rgba(cs(d.body).backgroundColor); g = bodyBg; }
    return !!g && lum(g) > 0.8;
  }

  /* Where the light goes in its section. Every V3 light section opens with its own soft light field (absolute, z-index 0,
     no pointer events) and keeps all of its content in positioned wrappers above it. When that holds ('over'), the veil
     and the ambient field go first in the section, under that field, and the lamp straight after it: over the section's
     own light, under every photo, card and word. Otherwise one layer drops to the back of the section at z-index -1,
     under everything ('in', 'iso' or 'ground'). */
  function overSpot(s) {
    var kids = [], i, k, kc, after = null;
    for (i = 0; i < s.children.length; i++) {
      k = s.children[i];
      if (/^(STYLE|SCRIPT|TEMPLATE|LINK|META)$/.test(k.tagName)) continue;
      kc = cs(k);
      if (kc.display === 'none') continue;
      kids.push([k, kc]);
    }
    var z = 0;
    for (i = 0; i < kids.length; i++) {
      kc = kids[i][1];
      var decor = (kc.position === 'absolute' || kc.position === 'fixed') && kc.pointerEvents === 'none' && (kc.zIndex === 'auto' || +kc.zIndex <= 0);
      if (!decor) break;
      after = kids[i][0];
      if (kc.zIndex !== 'auto' && +kc.zIndex < z) z = +kc.zIndex;
    }
    for (; i < kids.length; i++) {
      kc = kids[i][1];
      if (kc.position === 'static' || kc.cssFloat !== 'none' || (kc.zIndex !== 'auto' && +kc.zIndex < 0)) return null;
    }
    return { after: after, z: z };
  }

  function mountHost(x, c) {
    var s = x.el, how, spot = overSpot(s);
    if (spot) how = 'over';
    else if (stacking(c)) how = 'in';
    else if (c.overflowX !== 'visible' && c.overflowY !== 'visible' && !hasFixed(s)) { s.classList.add('lt-iso'); how = 'iso'; }
    else how = 'ground';
    var L = d.createElement('div');
    L.className = 'lt-host'; L.setAttribute('aria-hidden', 'true');
    if (how === 'ground') {
      /* the section cannot become a stacking context safely, so its ground moves onto this layer (same paint, one level down) */
      var bg = rgba(c.backgroundColor);
      L.style.backgroundColor = bg && bg[3] > 0 ? c.backgroundColor : cs(d.body).backgroundColor;
      if (c.backgroundImage && c.backgroundImage !== 'none') {
        L.style.backgroundImage = c.backgroundImage; L.style.backgroundSize = c.backgroundSize;
        L.style.backgroundPosition = c.backgroundPosition; L.style.backgroundRepeat = c.backgroundRepeat;
      }
      s.classList.add('lt-sec');
    }
    /* The veil and the ambient field go UNDER the section's own designed light field (so its warmth and depth survive),
       the lamp goes over it. Where the section has its own field ('over'), that takes two layers: one first in the
       section, one straight after the field. Otherwise one layer at the back holds all three, under everything. */
    var U = L;
    if (how === 'over') {
      U = d.createElement('div');
      U.className = 'lt-host lt-host--under'; U.setAttribute('aria-hidden', 'true');
      if (spot.z < 0 && stacking(c)) U.style.zIndex = String(spot.z);
    }
    /* on a white ground the veil is lighter still: white sections are there to read as white */
    var g = rgba(c.backgroundColor);
    if (/\bsec--white\b/.test(s.className || '') || (g && g[3] > 0.5 && lum(g) > 0.995)) U.className += ' lt-host--white';
    if (A) U.appendChild(x.veil = span('lt-veil'));
    if (B) {
      x.field = span('lt-field'); x.blobs = [];
      for (var i = 1; i <= 4; i++) { var b = span('lt-blob lt-blob--' + i); x.blobs.push(b); x.field.appendChild(b); }
      U.appendChild(x.field);
    }
    if (A) L.appendChild(x.lamp = span('lt-lamp'));
    x.hosts = [];
    if (how === 'over') {
      if (U.firstChild) { s.insertBefore(U, s.firstChild); x.hosts.push(U); }
      if (L.firstChild) {
        L.className += ' lt-host--over';
        s.insertBefore(L, spot.after ? spot.after.nextSibling : (U.parentNode ? U.nextSibling : s.firstChild));
        x.hosts.push(L);
      }
    } else { s.insertBefore(L, s.firstChild); x.hosts.push(L); }
    x.host = L; x.how = how;
  }

  function collect(x) {
    var s = x.el, all = s.getElementsByTagName('*'), cards = [], glass = [], btns = [], heads = [], i, el, c, r, glassy;
    function inside(list, el) { for (var k = 0; k < list.length; k++) if (list[k].el.contains(el)) return true; return false; }
    for (i = 0; i < all.length; i++) {
      el = all[i];
      if (NOKIDS.test(el.tagName)) continue;
      var isBtn = el.classList.contains('btn'), isHead = /^H[12]$/.test(el.tagName) || el.classList.contains('h1') || el.classList.contains('h2');
      var tilt = el.hasAttribute('data-tilt');
      c = null; glassy = false;
      if (!isBtn && !isHead && !tilt) {
        c = cs(el);
        glassy = (c.backdropFilter && c.backdropFilter !== 'none') || (c.webkitBackdropFilter && c.webkitBackdropFilter !== 'none') || /115deg/.test(c.backgroundImage);
        if (!glassy) continue;
      }
      if (el.closest('.flip,[data-flip],[data-marquee]')) continue;
      c = c || cs(el);
      if (c.display === 'none' || c.visibility === 'hidden') continue;
      r = el.getBoundingClientRect();
      if (tilt && !glassy) glassy = (c.backdropFilter && c.backdropFilter !== 'none') || /115deg/.test(c.backgroundImage);
      /* A: cards that can carry a shadow outside their own box (light grounds only). A tilt card needs a surface of its
         own (a fill, an edge or a shadow): a photo with a caption under it on the paper must not grow a plate. */
      if (A && x.light && (glassy || (tilt && surface(c))) && r.width >= 150 && r.height >= 80 && c.overflowX === 'visible' && c.overflowY === 'visible' &&
          !inside(cards, el) && positionable(el, c)) cards.push({ el: el, pos: c.position === 'static' });
      if (!C) continue;
      /* C: glass that takes a specular band */
      if (glassy && r.width >= 100 && r.height >= 56 && c.transformStyle !== 'preserve-3d' && !inside(glass, el) && positionable(el, c)) {
        glass.push({ el: el, pos: c.position === 'static', kind: lum(rgba(c.color)) > 0.5 ? 'dark' : 'light', f: 0.46 });
      } else if (isBtn && r.width >= 60 && r.height >= 30 && positionable(el, c)) {
        var bg = rgba(c.backgroundColor), kind;
        if (!bg || bg[3] < 0.3) kind = lum(rgba(c.color)) > 0.5 ? 'dark' : 'light';
        else kind = lum(bg) < 0.35 ? 'navybtn' : lum(bg) > 0.8 ? 'whitebtn' : 'light';
        btns.push({ el: el, pos: c.position === 'static', kind: kind, f: 0.62 });
      } else if (isHead && x.light && parseFloat(c.fontSize) >= 34 && !el.querySelector('[data-count]') && !inside(heads, el) && positionable(el, c)) {
        heads.push({ el: el, pos: c.position === 'static', c: c });
      }
    }
    return { cards: cards, glass: glass.concat(btns), heads: heads };
  }

  function mountCard(q) {
    if (q.pos) q.el.classList.add('lt-pos');
    q.l = span('lt-cs lt-cs--l'); q.r2 = span('lt-cs lt-cs--r');
    q.el.appendChild(q.l); q.el.appendChild(q.r2);
  }
  function mountSheen(q) {
    if (q.pos) q.el.classList.add('lt-pos');
    q.el.classList.add('lt-iso');
    q.clip = span('lt-sp lt-sp--' + q.kind); q.b = span('lt-sp__b');
    q.clip.appendChild(q.b); q.el.appendChild(q.clip);
  }
  /* the heading's own words, copied into a masked band that lies exactly on top of them; dropped if the copy would not line up */
  function lines(range) {
    var out = [], rs = range.getClientRects();
    for (var i = 0; i < rs.length; i++) if (rs[i].width > 0.5) out.push(rs[i]);
    return out;
  }
  function mountHead(q) {
    var h = q.el, c = q.c;
    if (q.pos) h.classList.add('lt-pos');
    var hs = span('lt-hs'), inn = span('lt-hs__in');
    hs.setAttribute('inert', '');
    hs.style.padding = c.paddingTop + ' ' + c.paddingRight + ' ' + c.paddingBottom + ' ' + c.paddingLeft;
    inn.innerHTML = h.innerHTML;
    var ns = inn.getElementsByTagName('*');
    for (var i = 0; i < ns.length; i++) {
      var n = ns[i];
      n.removeAttribute('id'); n.removeAttribute('tabindex'); n.removeAttribute('href');
      for (var j = n.attributes.length - 1; j >= 0; j--) if (/^data-/.test(n.attributes[j].name)) n.removeAttribute(n.attributes[j].name);
    }
    hs.appendChild(inn); h.appendChild(hs);
    var ro = d.createRange(), rc = d.createRange(), good = false;
    try {
      ro.setStart(h, 0); ro.setEndBefore(hs); rc.selectNodeContents(inn);
      var a = lines(ro), b = lines(rc);
      good = a.length > 0 && a.length === b.length && a.length <= 24;
      for (i = 0; good && i < a.length; i++) {
        if (Math.abs(a[i].left - b[i].left) > 1.5 || Math.abs(a[i].top - b[i].top) > 1.5 || Math.abs(a[i].width - b[i].width) > 1.5) good = false;
      }
    } catch (e) { good = false; }
    if (!good) { h.removeChild(hs); if (q.pos) h.classList.remove('lt-pos'); return false; }
    q.hs = hs; q.inn = inn;
    return true;
  }

  function initSection(x) {
    x.ready = true;
    var s = x.el, c = cs(s);
    x.light = lightGround(s, c);
    if (x.light && c.position === 'static') x.light = false; /* nothing to hang a layer on */
    var found = collect(x);   /* every read happens before the first write */
    if (x.light && (A || B)) mountHost(x, c);
    x.cards = found.cards; x.cards.forEach(mountCard);
    x.sheens = found.glass; x.sheens.forEach(mountSheen);
    x.heads = found.heads.filter(mountHead);
    x.pouches = [];
    if (A && x.light) {
      var tts = s.querySelectorAll('.tt');
      for (var i = 0; i < tts.length; i++) {
        var p = { el: tts[i], sh: span('lt-tt') };
        tts[i].insertBefore(p.sh, tts[i].firstChild);
        /* the foil catches the light: a soft glow on the side facing the pointer (A), and in C a narrow specular band
           that runs across the pouch. Screen-blended over the canvas, so the paper around the pouch hardly changes.
           Only on the cut frames (transparent ground); the navy studio frames blend on dark grounds and are left alone. */
        if (/turntable-cut/.test(tts[i].getAttribute('data-src') || '')) {
          p.box = span('lt-pl');
          p.glow = span('lt-pl__g');
          p.box.appendChild(p.glow);
          if (C) { p.spec = span('lt-pl__s'); p.box.appendChild(p.spec); }
          tts[i].appendChild(p.box);
        }
        x.pouches.push(p);
      }
    }
    if (w.ResizeObserver) { new ResizeObserver(function () { dirty = true; kick(); }).observe(s); }
    /* let the first paint land at opacity 0, then fade the light in */
    setTimeout(function () {
      (x.hosts || []).forEach(function (h) { h.classList.add('is-lit'); });
      x.pouches.forEach(function (p) { p.sh.classList.add('is-lit'); });
    }, 80);
  }

  function resync(x) {
    /* every section's ambient shapes run on one clock, so two light sections meet without a seam */
    if (!x.blobs) return;
    var now = d.timeline && d.timeline.currentTime != null ? d.timeline.currentTime : (w.performance ? performance.now() : 0);
    x.blobs.forEach(function (b) {
      if (!b.getAnimations) return;
      b.getAnimations().forEach(function (an) { try { an.currentTime = now; } catch (e) {} });
    });
  }

  var list = d.querySelectorAll('main section');
  for (var si = 0; si < list.length; si++) {
    var sec = list[si];
    if (sec.parentElement && sec.parentElement.closest('section')) continue;
    var x0 = { el: sec, ready: false, vis: false, r: null, cards: [], sheens: [], heads: [], pouches: [] };
    sec.__lt = x0; secs.push(x0);
  }
  if (!secs.length) { html.classList.remove('lt', 'lt-' + MODE, 'lt-fine', 'lt-touch'); return; }

  /* ---------- the one loop ---------- */
  var queued = false, raf = 0, last = 0, dirty = true, hidden = !!d.hidden, stopped = false;
  function kick() { if (!queued && !hidden && !stopped) { queued = true; raf = w.requestAnimationFrame(tick); } }

  function measure(x) {
    x.r = x.el.getBoundingClientRect();
    var i, q, r;
    for (i = 0; i < x.cards.length; i++) x.cards[i].r = x.cards[i].el.getBoundingClientRect();
    for (i = 0; i < x.pouches.length; i++) {
      q = x.pouches[i]; q.r = q.el.getBoundingClientRect();
      if (q.box) q.br = q.box.getBoundingClientRect();
    }
    for (i = 0; i < x.sheens.length; i++) {
      q = x.sheens[i]; r = q.r = q.el.getBoundingClientRect();
      q.nbw = Math.round(clamp(r.width * q.f, 70, 340));
    }
    for (i = 0; i < x.heads.length; i++) {
      q = x.heads[i]; r = q.r = q.el.getBoundingClientRect();
      q.nbw = Math.round(clamp(r.width * 0.34, 160, 440));
    }
  }

  function write(x) {
    var r = x.r, i, q, qr, cx, cy, nx, near, k, X;
    if (!r) return;
    if (x.lamp) setT(x, 'l', x.lamp, lx - r.left - LSZ / 2, ly - r.top - LSZ / 2);
    if (x.field) setT(x, 'f', x.field, (lx - vw / 2) * 0.12, -r.top + (ly - vh / 2) * 0.10);
    /* A: shadows lean away from the light */
    for (i = 0; i < x.cards.length; i++) {
      q = x.cards[i]; qr = q.r;
      if (!qr || !qr.width) continue;
      cx = qr.left + qr.width / 2;
      nx = clamp((lx - cx) / (qr.width / 2 + 240), -1, 1);
      near = smooth(1 - clamp(distTo(qr, lx, ly) / 640, 0, 1));
      k = A * (0.28 + 0.72 * near);
      setO(q, 'ol', q.l, k * clamp(0.5 + 0.5 * nx, 0, 1));
      setO(q, 'or', q.r2, k * clamp(0.5 - 0.5 * nx, 0, 1));
    }
    for (i = 0; i < x.pouches.length; i++) {
      q = x.pouches[i]; qr = q.r;
      if (!qr || !qr.width) continue;
      nx = clamp((lx - (qr.left + qr.width / 2)) / (qr.width * 0.9), -1, 1);
      X = -nx * qr.width * 0.07;
      var sc = 1 + Math.abs(nx) * 0.14;
      if (q.x === undefined || Math.abs(q.x - X) > 0.1) { q.x = X; q.sh.style.transform = 'translate3d(' + X.toFixed(1) + 'px,0,0) scaleX(' + sc.toFixed(3) + ')'; }
      var br = q.br;
      if (!br || !br.width) continue;
      /* the glow leans to the side of the pouch that faces the lamp and brightens as the lamp comes near */
      cx = br.left + br.width / 2;
      nx = clamp((lx - cx) / (br.width * 0.8), -1, 1);
      near = smooth(1 - clamp(distTo(br, lx, ly) / 700, 0, 1));
      setT(q, 'g', q.glow, nx * br.width * 0.3, 0);
      setO(q, 'go', q.glow, A * (0.35 + 0.65 * near));
      if (q.spec) {
        /* the specular band sweeps the width of the pouch as the pointer crosses it, a little faster than the pointer */
        X = br.width / 2 + clamp((sx - (br.left + br.width / 2)) * 1.25, -br.width * 0.62, br.width * 0.62);
        setT(q, 's', q.spec, X, 0);
        setO(q, 'so', q.spec, smooth(1 - clamp(distTo(br, sx, sy) / 520, 0, 1)));
      }
    }
    /* C: a specular band crosses each surface while the pointer crosses it (a wider catch area for small ones) */
    for (i = 0; i < x.sheens.length; i++) {
      q = x.sheens[i]; qr = q.r;
      if (!qr || !qr.width) continue;
      if (q.bw !== q.nbw) { q.bw = q.nbw; q.b.style.setProperty('--lt-bw', q.bw + 'px'); }
      cx = qr.left + qr.width / 2;
      X = qr.width / 2 + (sx - cx) * (qr.width * 1.35 / Math.max(qr.width, 560)) - q.bw / 2;
      setT(q, 't', q.b, X, 0);
      setO(q, 'o', q.b, smooth(1 - clamp(distTo(qr, sx, sy) / 460, 0, 1)));
    }
    for (i = 0; i < x.heads.length; i++) {
      q = x.heads[i]; qr = q.r;
      if (!qr || !qr.width) continue;
      if (q.bw !== q.nbw) { q.bw = q.nbw; q.hs.style.setProperty('--lt-bw', q.bw + 'px'); }
      cx = qr.left + qr.width / 2;
      X = qr.width / 2 + (sx - cx) - q.bw / 2;
      if (q.tx === undefined || Math.abs(q.tx - X) > 0.1) {
        q.tx = X;
        q.hs.style.transform = 'translate3d(' + X.toFixed(1) + 'px,0,0)';
        q.inn.style.transform = 'translate3d(' + (-X).toFixed(1) + 'px,0,0)';
      }
      setO(q, 'o', q.hs, smooth(1 - clamp(distTo(qr, sx, sy) / 640, 0, 1)));
    }
  }

  function tick(t) {
    queued = false;
    if (stopped) return;
    var dt = last ? clamp(t - last, 1, 64) : 16.7, i, x;
    last = t;
    var kL = 1 - Math.exp(-dt * (FINE ? 0.0048 : 0.0024)), kS = 1 - Math.exp(-dt * (FINE ? 0.011 : 0.0040));
    lx += (tx - lx) * kL; ly += (ty - ly) * kL;
    sx += (tx - sx) * kS; sy += (ty - sy) * kS;
    if (dirty) { for (i = 0; i < secs.length; i++) { x = secs[i]; if (x.vis && x.ready) measure(x); } }
    dirty = false;
    for (i = 0; i < secs.length; i++) { x = secs[i]; if (x.vis && x.ready) write(x); }
    var moving = Math.abs(tx - lx) > 0.25 || Math.abs(ty - ly) > 0.25 || Math.abs(tx - sx) > 0.25 || Math.abs(ty - sy) > 0.25;
    if (moving) kick(); else last = 0;
  }

  /* ---------- visibility: set up a section when it first comes near, and only work on the ones in view ---------- */
  function seen(x, on) {
    x.vis = on;
    if (on && !x.ready) initSection(x);
    x.el.classList.toggle('lt-in', on);
    if (on) resync(x);
  }
  if (w.IntersectionObserver) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.target.__lt) seen(e.target.__lt, e.isIntersecting); });
      dirty = true; kick();
    }, { rootMargin: '25% 0px 25% 0px' });
    secs.forEach(function (x) { io.observe(x.el); });
  } else {
    secs.forEach(function (x) { seen(x, true); });
  }

  /* ---------- inputs ---------- */
  if (FINE) {
    w.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'touch') return;
      tx = e.clientX; ty = e.clientY; kick();
    }, { passive: true });
  }
  w.addEventListener('scroll', function () { dirty = true; if (!FINE) drift(); kick(); }, { passive: true });
  w.addEventListener('resize', function () { view(); dirty = true; if (!FINE) drift(); kick(); }, { passive: true });
  w.addEventListener('load', function () { dirty = true; kick(); });
  d.addEventListener('visibilitychange', function () {
    hidden = !!d.hidden;
    if (hidden) { if (queued) { w.cancelAnimationFrame(raf); queued = false; } last = 0; }
    else { dirty = true; kick(); }
  });
  function off() {
    stopped = true;
    if (queued) { w.cancelAnimationFrame(raf); queued = false; }
    html.classList.remove('lt', 'lt-a', 'lt-b', 'lt-c', 'lt-fine', 'lt-touch');
  }
  if (RMQ) {
    var onRM = function (e) { if (e.matches) off(); };
    if (RMQ.addEventListener) RMQ.addEventListener('change', onRM); else if (RMQ.addListener) RMQ.addListener(onRM);
  }

  /* a read-only view for checks in the browser console */
  w.__thLight = {
    mode: MODE, fine: FINE,
    stats: function () {
      var o = { sections: 0, hosts: 0, cards: 0, pouches: 0, sheens: 0, heads: 0, how: [] };
      secs.forEach(function (x) {
        if (!x.ready) return;
        o.sections++; if (x.hosts && x.hosts.length) { o.hosts += x.hosts.length; o.how.push((x.el.id || '?') + ':' + x.how); }
        o.cards += x.cards.length; o.pouches += x.pouches.length; o.sheens += x.sheens.length; o.heads += x.heads.length;
      });
      return o;
    }
  };
  kick();
})();
